import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaBootstrap,
  FaNodeJs,
  FaAws,
  FaGitAlt,
  FaWordpress,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiMui,
  SiJquery,
  SiExpress,
  SiMongodb,
  SiGooglecloud,
  SiShopify,
} from "react-icons/si";
import { FaProjectDiagram } from "react-icons/fa";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CardCarousel.css";
export default function CardCarousel() {
  const [slides, setSlides] = useState(4);

  // ✅ CONTROL SLIDES MANUALLY (NO SLICK RESPONSIVE)
  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;

      if (width < 640) {
        setSlides(1);
      } else if (width < 1024) {
        setSlides(2);
      } else {
        setSlides(4);
      }
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: slides,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1200,
    autoplaySpeed: 2500,
    cssEase: "ease-in-out",
  };

  const cards = [
    { icon: <FaHtml5 size={70} color="#9AFFA6" />, title: "HTML" },
    { icon: <FaCss3Alt size={70} color="#9AFFA6" />, title: "CSS" },
    { icon: <FaJs size={70} color="#9AFFA6" />, title: "JavaScript" },
    {
      icon: <SiTailwindcss size={70} color="#9AFFA6" />,
      title: "Tailwind CSS",
    },
    { icon: <SiMui size={70} color="#9AFFA6" />, title: "Material UI" },
    { icon: <FaBootstrap size={70} color="#9AFFA6" />, title: "Bootstrap" },
    { icon: <SiJquery size={70} color="#9AFFA6" />, title: "jQuery" },
    { icon: <FaReact size={70} color="#9AFFA6" />, title: "React.js" },
    { icon: <FaNodeJs size={70} color="#9AFFA6" />, title: "Node.js" },
    { icon: <SiExpress size={70} color="#9AFFA6" />, title: "Express.js" },
    { icon: <SiMongodb size={70} color="#9AFFA6" />, title: "MongoDB" },
    {
      icon: <SiGooglecloud size={70} color="#9AFFA6" />,
      title: "Google Cloud",
    },
    { icon: <FaAws size={70} color="#9AFFA6" />, title: "AWS" },
    { icon: <FaGitAlt size={70} color="#9AFFA6" />, title: "Git & GitHub" },
    {
      icon: <FaProjectDiagram size={70} color="#9AFFA6" />,
      title: "Agile Methodologies",
    },
    { icon: <FaWordpress size={70} color="#9AFFA6" />, title: "WordPress" },
    { icon: <SiShopify size={70} color="#9AFFA6" />, title: "Shopify" },
  ];

  return (
    <div>
      <div className="pt-10 lg:pt-28 pb-20">
        {/* ✅ YOUR REQUIRED WIDTH BEHAVIOR */}
        <div
          className="relative max-w-full lg:max-w-7xl mx-auto "
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <Slider {...settings}>
            {cards.map((card, index) => (
              <div key={index} className="px-2 sm:px-3 mb-10">
                <div className="bg-[#ffffff0a] rounded-2xl p-8 h-64 flex flex-col justify-between shadow-lg">
                  <div className="flex justify-between items-start">
                    {card.icon}
                    {/* <div className="bg-gradient-to-br from-green-300 to-lime-300 rounded-full w-12 h-12 flex items-center justify-center">
                      <NorthEastIcon sx={{ fontSize: 20, color: "#0A1C1B" }} />
                    </div> */}
                  </div>

                  <h3 className="text-[#F8F8F8] font-semibold text-xl mt-6">
                    {card.title}
                  </h3>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className=" relative text-center px-4">
        <p className="text-[#F8F8F8] text-[14px] md:text-[16px]">
          Build powerful web applications with modern development solutions.
          <Link className="ml-1 bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
            Let’s bring your ideas to life today!!
          </Link>
        </p>
      </div>
    </div>
  );
}
